import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { IoClose, IoCheckmarkCircle, IoWarningOutline, IoInformationCircle } from '../../node_modules/react-icons/io5/index.esm.js';
import Element from '../Element/index.js';
import Button from '../Button/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const alertVariantToClassNameMap = {
  success: styles.success,
  error: styles.error,
  info: styles.info
};
const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};
const icon = {
  success: /*#__PURE__*/React.createElement(IoCheckmarkCircle, {
    className: styles.icon
  }),
  error: /*#__PURE__*/React.createElement(IoWarningOutline, {
    className: styles.icon
  }),
  info: /*#__PURE__*/React.createElement(IoInformationCircle, {
    className: styles.icon
  })
}; // TODO: Get this value from CSS vars

const TRANSITION_DURATION = 500; // 300 + 200
// duration-transition-medium + duration-delay-short

function Alert(props) {
  const {
    name,
    className,
    variant = 'info',
    children,
    onCloseButtonClick,
    nonDismissable,
    duration = 0,
    onTimeout,
    hideIcon,
    spacing = 'loose'
  } = props;
  const alertElementRef = React.useRef(null);
  const [hidden, setHidden] = React.useState(false);
  React.useEffect(() => {
    const {
      current: el
    } = alertElementRef;

    if (el) {
      const bcr = el.getBoundingClientRect();
      el.style.setProperty('--height', `${bcr.height}px`);
    }
  }, []);
  React.useEffect(() => {
    let hideTimeoutId;

    if (duration > 0 && duration !== Infinity) {
      hideTimeoutId = window.setTimeout(() => {
        setHidden(true);

        if (onTimeout) {
          onTimeout(name, TRANSITION_DURATION);
        }
      }, duration);
    }

    return () => {
      if (hideTimeoutId) {
        window.clearTimeout(hideTimeoutId);
      }
    };
  }, [duration, setHidden, onTimeout, name]);
  const handleCloseButtonClick = React.useCallback(() => {
    setHidden(true);

    if (onCloseButtonClick) {
      onCloseButtonClick(name, TRANSITION_DURATION);
    }
  }, [onCloseButtonClick, name]);
  return /*#__PURE__*/React.createElement(Element, {
    elementRef: alertElementRef,
    className: _cs(styles.alert, className, alertVariantToClassNameMap[variant], spacingToStyleMap[spacing], hidden && styles.hidden),
    icons: !hideIcon && icon[variant],
    childrenContainerClassName: styles.content,
    iconsContainerClassName: styles.iconContainer,
    actionsContainerClassName: styles.actionContainer,
    actions: !nonDismissable && /*#__PURE__*/React.createElement(Button, {
      className: styles.closeButton,
      name: undefined,
      onClick: handleCloseButtonClick,
      variant: "action",
      disabled: hidden
    }, /*#__PURE__*/React.createElement(IoClose, {
      className: styles.icon
    })),
    spacing: spacing
  }, children);
}

var Alert$1 = genericMemo(Alert);

export { Alert$1 as default };
//# sourceMappingURL=index.js.map
